export default "__VITE_ASSET__66b7ec0f__"